// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
export const fetchParticularAutoLoanIndexDetails = (fetchData: any) => {
	const data = {
		getParticularAutoLoanIndexDetailsDataToken: fetchData,
	};
	const url = `${API_URL}getParticularAutoLoanIndexDetail`;
	return makeApiCall(url, data);
};
/*********** FETCH PARTICULAR LOAN INDEX START ************************ */

/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
export const createHDFCIndividualQRCode = (fetchData: any) => {
	const data = {
		CreateNewIndividualQRForHDFCToken: fetchData,
	};
	const url = `${API_URL}HdfcCollection/hdfcCreateIndividualQrCode`;
	return makeApiCall(url, data);
};
/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

/*********** GROUP WISE AUTO LOAN LIST START  ************************ */
export const groupWiseAutoLoanList = (fetchData: any) => {
	const data = {
		GetAllAutoLoanIndexListToken: fetchData,
	};
	const url = `${API_URL}getAutoLoanIndexListGroup`;
	return makeApiCall(url, data);
};
/*********** GROUP WISE AUTO LOAN LIST END  ************************ */

/*************** ADD AUTO LOAN DISBURSEMENT START *************** */
export const addAutoLoanIndexDisbursement = (fetchData: any) => {
	const data = {
		CreateAutoLoanIndexToken: fetchData,
	};
	const url = `${API_URL}addAutoLoanDisbursement`;
	return makeApiCall(url, data);
};
/*************** ADD AUTO LOAN DISBURSEMENT END *************** */

/*************** ADD AUTO LOAN DISBURSEMENT START *************** */
export const getautoLoanIndexScheduleDetail = (fetchData: any) => {
	const data = {
		getAutoLoanScheduleToken: fetchData,
	};
	const url = `${API_URL}getAutoLoanIndexSchedule`;
	return makeApiCall(url, data);
};
/*************** ADD AUTO LOAN DISBURSEMENT END *************** */

/*************** DELETE PARTICULAR AUTO LOAN INDEX START *************** */
export const deleteParticularAutoLoanIndexDetail = (fetchData: any) => {
	const data = {
		DeleteParticularAutoLoanIndexToken: fetchData,
	};
	const url = `${API_URL}deleteParticularAutoLoanIndex`;
	return makeApiCall(url, data);
};
/*************** DELETE PARTICULAR AUTO LOAN INDEX END *************** */
